import './offers-carousel.css';
